import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  headerContainer: {
    marginBottom: 5,
    textAlign: "right",
  },
  headerboucher: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#1f2937", // Matching text-gray-800
    marginBottom: 5,
  },
  headerbouchercontent: {
    fontSize: 10,
    color: "#374151", // Matching text-gray-700
    fontStyle: "italic",
    marginBottom: 0,
  },
  accentText: {
    color: "#ff8e4d", // Same orange accent color as before
  },
});

const BillVoucher = ({ invoice }) => (
  <View style={styles.headerContainer}>
    <Text style={styles.headerboucher}>
      Payment <Text style={styles.accentText}>Voucher</Text>
    </Text>
    <Text style={styles.headerbouchercontent}>
      Please present either an electronic or paper copy of your booking
      confirmation upon check-in
    </Text>
  </View>
);

export default BillVoucher;
